import Input from "../../components/form/input/InputField"
import Label from "../../components/form/Label";

import type { UseFormRegister, FieldValues, Control, Path } from "react-hook-form";
import type { MenuItem } from "../../types/menuItemTypes";

type NutrientsInput<T extends FieldValues> = {
  menuItem?: MenuItem;
  register: UseFormRegister<T>;
  control: Control<T>
}

const NutrientsInput = <T extends FieldValues>({
  register,
}: NutrientsInput<T>) => {
  return (
    <div className="overflow-y-auto custom-scrollbar">
      <div className="grid grid-cols-1 gap-x-6 gap-y-5 lg:grid-cols-2">
        <div className="rounded-2xl p-4 border border-gray-100 dark:border-gray-700">
          <Label>Сalories</Label>
          <div className='flex items-center'>
            <Input
              id="calories"
              parentClassName='w-full' 
              type="number" 
              placeholder='Enter calories value'
              {...register('calories' as Path<T>, { valueAsNumber: true })} 
            />
            <span className='ml-2 text-gray-800 dark:text-white/90'>kcal</span>
          </div>
          {/* TODO: proteins, fats, carbohydrates */}
        </div>
      </div>  
    </div>
  )
}

export default NutrientsInput
